<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
      currentChat: 'getSelectedChat',
      teams: 'teams/getTeams',
    }),
    // Company-team of the open conversation, derived from its inbox name
    // (S3 inboxes end with "S3", MK with "MK"). Team-scoped canned responses
    // only show inside their own company's conversations — a null team_id is
    // global (both companies). Keeps Smith3D canned replies out of MakerHub.
    currentCompanyTeamId() {
      const inbox = this.$store.getters['inboxes/getInbox'](
        this.currentChat?.inbox_id
      );
      const name = (inbox?.name || '').trim().toUpperCase();
      const teamName = name.endsWith('S3') ? 'smith3d' : 'makerhub';
      const team = (this.teams || []).find(t => t.name === teamName);
      return team?.id ?? null;
    },
    items() {
      return this.cannedMessages
        .filter(
          cannedMessage =>
            cannedMessage.team_id == null ||
            cannedMessage.team_id === this.currentCompanyTeamId
        )
        .map(cannedMessage => ({
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: cannedMessage.content,
        }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
